import CustomTable from "@/components/CustomTable/CustomTable.vue";
import { format_date } from "@/utils/date_formatter";
import Swal from "sweetalert2";
import NavBar from "@/components/NavBar/NavBar.vue";
import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";
import { LOGOUT } from "@/utils/logout.js";

export default {
  name: "project_table",
  mixins: [LOGOUT],
  components: {
    NavBar,
    CustomTable,
  },
  data: () => ({
    onboarding_link: "",
    project_name: "",
    project_description: "",
    active_workflows: 0,
    date_created: "",
    loading: false,
    selected_project_id: null,
    success_message: "", // Add success message state
    role: "",
    error_messages: "",
    can_create_workflow: false,
    isInitializing: true,
    projectsHeading: "Your Projects",
    columns: [
      { label: "Project Name", key: "project_name" },
      { label: "Number Of Workflows", key: "workflow_count" },
      { label: "Date Created", key: "date_created" },
    ],
    projectsTableKey: 0,
    // Application Status management properties
    project_statuses: [],
    show_status_form: false,
    editing_status: null,
    new_status_name: "",
    new_status_color: "#17a2b8",
  }),

  computed: {
    project_id() {
      return this.$store.getters.get_project_id;
    },
    headerButtons() {
      const buttons = [
        {
          label: 'View Link',
          icon: 'fa fa-arrows',
          class: 'btn-dark',
          action: 'view-link',
          title: 'View Onboarding Link',
        },
      ];
      if (this.role === 'ClientAdmin' || (this.role === 'Client' && this.can_create_workflow)) {
        buttons.unshift({
          label: 'New Project',
          icon: 'fas fa-plus',
          class: 'btn-dark',
          action: 'create-project',
          title: 'Create a New Project',
        });
      }
      return buttons;
    }
  },
  methods: {
    formatDate(date) {
      return format_date(date);
    },
    getUserData() {
      const TOKEN = localStorage.getItem("token");
      const API_URL = `${API_BASE_URL}/verify_api/system_management_api/get_user_api/`;

      $.ajax({
        url: API_URL,
        method: "GET",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading user data...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.redirect) {
            this.logout();
            return;
          }

          if (response.status === "success") {
            const userData = response.data;
            if (!this.isUserDataLoaded) {
              this.role = userData.user_role;
              this.can_create_workflow = response.can_create_workflow;
              this.isUserDataLoaded = true;
            }
          }
        },
        error: (error) => {
          Swal.close();
          if (error.responseJSON?.redirect) {
            this.logout();
            return;
          }

          Swal.fire({
            icon: "error",
            text: error.responseJSON?.error || "Failed to load user data",
            confirmButtonText: "OK",
          });
        },
      });
    },
    clean_create_project_modal() {
      if (this.selected_project_id !== null) {
        this.project_name = "";
        this.project_description = "";
      }
    },
    get_onboarding_link() {
      const TOKEN = localStorage.getItem("token");
      const GET_ONBOARDING_LINK_API = `${API_BASE_URL}/verify_api/workflow_management_api/get_onboarding_link_api/`;
      $.ajax({
        url: GET_ONBOARDING_LINK_API,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          this.loading = true;
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();

          if (response.redirect) {
            this.logout();
            return;
          }
          this.onboarding_link = response.onboarding_link;
          this.role = response.role;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          Swal.close();
        },
      });
    },
    get_projects(page = 1, search = "") {
      const TOKEN = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        let url = `${API_BASE_URL}/verify_api/workflow_management_api/get_projects_api/?page=${page}`;
        if (search) {
          url += `&search=${encodeURIComponent(search)}`;
        }
        $.ajax({
          url: url,
          method: "GET",
          dataType: "json",
          headers: {
            Authorization: `Token ${TOKEN}`,
          },
          success: (data) => {
            if (!this.isUserDataLoaded) {
              this.can_create_workflow = data.can_create_workflow;
              this.role = data.role;
            }
            resolve({
              count: data.count,
              results: data.results,
            });
          },
          error: (xhr, status, error) => {
            reject(error);
          },
        });
      });
    },
    validate_inputs() {
      if (!this.project_name.trim()) {
        $(".project-name-messages").removeClass("d-none");
        setTimeout(() => {
          $(".project-name-messages").addClass("d-none");
        }, 3000);
        return false;
      }

      if (!this.project_description.trim()) {
        $(".project-description-messages").removeClass("d-none");
        setTimeout(() => {
          $(".project-description-messages").addClass("d-none");
        }, 3000);
        return false;
      }

      return true;
    },
    create_project() {
      if (!this.validate_inputs()) {
        return;
      }
      const TOKEN = localStorage.getItem("token");
      const COMPANY_PROFILE_ID = localStorage.getItem("company_profile_id");

      const FORM_DATA = {
        project_name: this.project_name,
        project_description: this.project_description,
        company_profile_id: COMPANY_PROFILE_ID,
      };

      const PROJECT_API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/create_project_api/`;

      $.ajax({
        url: PROJECT_API_URL,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          localStorage.setItem("user_state", "created_project");
          let status = response.status;

          if (status === "success") {
            const project_id = response.project_id;
            this.$store.commit("set_project_id", project_id);
            this.$router.push({ name: "project_dashboard" });
            $("#create_project").modal("hide");
          } else {
            let error_message = response.message;
            // Display the error message using SweetAlert2
            Swal.fire({
              icon: "error",
              title: "Error",
              text: error_message,
              confirmButtonColor: "#59FF74",
              showConfirmButton: true,
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error Creating Project";
          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;
            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;

              $(".error-messages").text(error_message).removeClass("d-none");

              setTimeout(() => {
                $(".error-messages").text("").addClass("d-none");
              }, 3000);
            }
          }
        },
      });
    },
    viewProject(project_id) {
      this.$store.dispatch("update_project_id", project_id);
      this.$router.push({ path: `project_dashboard/` });
    },
    edit_project(project) {
      if (project) {
        this.selected_project_id = project.id; // Set the selected project ID here
        this.project_name = project.project_name;
        this.project_description = project.project_description;
        this.$nextTick(() => {
          $("#edit_project_modal").modal("show");
        });
      }
    },
    update_project() {
      if (!this.validate_inputs()) {
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const FORM_DATA = {
        project_name: this.project_name,
        project_description: this.project_description,
      };

      const EDIT_PROJECT_API_URL = `${API_BASE_URL}/verify_api/workflow_management_api/edit_project_api/${this.selected_project_id}`;

      $.ajax({
        url: EDIT_PROJECT_API_URL,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Updating project...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: () => {
          Swal.close();
          $("#edit_project_modal").modal("hide");
          this.projectsTableKey++;
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error Updating Project";

          if (error.responseJSON) {
            const ERROR_RESPONSE = error.responseJSON;

            if (ERROR_RESPONSE && ERROR_RESPONSE.error) {
              error_message = ERROR_RESPONSE.error;

              $(".error-messages").text(error_message).removeClass("d-none");

              setTimeout(() => {
                $(".error-messages").text("").addClass("d-none");
              }, 3000);
            }
          }
        },
      });
    },
    copy_onboarding_link() {
      navigator.clipboard
        .writeText(this.onboarding_link)
        .then(() => {
          this.success_message = "Link copied to clipboard!";
          this.error_messages = "";
        })
        .catch(() => {
          this.error_messages = "Failed to copy the link.";
          this.success_message = "";
        });
    },

    // Application Status Management Methods
    open_application_status_modal(project) {
      this.selected_project_id = project.id;
      this.project_statuses = [];
      this.show_status_form = false;
      this.editing_status = null;
      this.new_status_name = "";
      this.new_status_color = "#17a2b8";

      // Load existing statuses for the project's workflows
      this.load_project_statuses(project.id);

      $("#application_status_modal").modal("show");
    },

    load_project_statuses(project_id) {
      const TOKEN = localStorage.getItem("token");

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/workflow_application_status/get_by_workflow/?project_id=${project_id}`,
        method: "GET",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Loading statuses...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.status === "success") {
            this.project_statuses = response.data || [];
          } else {
            console.error("Failed to load project statuses:", response.message);
            this.project_statuses = [];
          }
        },
        error: (error) => {
          Swal.close();
          console.error("Error loading project statuses:", error);
          this.project_statuses = [];
          Swal.fire({
            icon: "error",
            text: "Failed to load project statuses",
            confirmButtonText: "OK",
          });
        },
      });
    },

    open_status_form() {
      this.show_status_form = true;
      this.editing_status = null;
      this.new_status_name = "";
      this.new_status_color = "#17a2b8";
    },

    cancel_status_edit() {
      this.show_status_form = false;
      this.editing_status = null;
      this.new_status_name = "";
    },

    create_or_update_status() {
      if (!this.new_status_name.trim()) {
        return;
      }

      if (this.editing_status) {
        this.update_workflow_status();
      } else {
        this.create_workflow_status();
      }
    },

    create_workflow_status() {
      const TOKEN = localStorage.getItem("token");

      const FORM_DATA = {
        project_id: this.selected_project_id,
        status_name: this.new_status_name.trim(),
        color: this.new_status_color,
      };

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/workflow_application_status/create/`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Creating status...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.status === "success") {
            this.project_statuses.push(response.data);
            this.cancel_status_edit();
            Swal.fire({
              icon: "success",
              text: "Status created successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.message || "Failed to create status",
              confirmButtonText: "OK",
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error creating status";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }
          Swal.fire({
            icon: "error",
            text: error_message,
            confirmButtonText: "OK",
          });
        },
      });
    },

    edit_status(status) {
      this.editing_status = status;
      this.new_status_name = status.status;
      this.new_status_color = status.color || "#17a2b8";
      this.show_status_form = true;
    },

    update_workflow_status() {
      const TOKEN = localStorage.getItem("token");

      const FORM_DATA = {
        status_id: this.editing_status.id,
        status_name: this.new_status_name.trim(),
        color: this.new_status_color,
      };

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/workflow_application_status/update/`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Updating status...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.status === "success") {
            // Update the status in the local array
            const index = this.project_statuses.findIndex(
              (s) => s.id === this.editing_status.id,
            );
            if (index !== -1) {
              this.project_statuses[index] = response.data;
            }
            this.cancel_status_edit();
            Swal.fire({
              icon: "success",
              text: "Status updated successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.message || "Failed to update status",
              confirmButtonText: "OK",
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error updating status";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }
          Swal.fire({
            icon: "error",
            text: error_message,
            confirmButtonText: "OK",
          });
        },
      });
    },

    delete_status(status) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to delete the status "${status.status}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.confirm_delete_status(status);
        }
      });
    },

    confirm_delete_status(status) {
      const TOKEN = localStorage.getItem("token");

      const FORM_DATA = {
        status_id: status.id,
      };

      $.ajax({
        url: `${API_BASE_URL}/verify_api/workflow_management_api/workflow_application_status/delete/`,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(FORM_DATA),
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        beforeSend: () => {
          Swal.fire({
            text: "Deleting status...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: (response) => {
          Swal.close();
          if (response.status === "success") {
            // Remove the status from the local array
            this.project_statuses = this.project_statuses.filter(
              (s) => s.id !== status.id,
            );
            Swal.fire({
              icon: "success",
              text: "Status deleted successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              icon: "error",
              text: response.message || "Failed to delete status",
              confirmButtonText: "OK",
            });
          }
        },
        error: (error) => {
          Swal.close();
          let error_message = "Error deleting status";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }
          Swal.fire({
            icon: "error",
            text: error_message,
            confirmButtonText: "OK",
          });
        },
      });
    },
    handleHeaderButtonClick(event) {
      const { action } = event;

      if (action === 'create-project') {
        this.clean_create_project_modal();
        $('#create_project').modal('show');
      } else if (action === 'view-link') {
        $('#view_link').modal('show');
      }
    },
  },
  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }
    this.getUserData();
    this.get_projects();
    this.get_onboarding_link();
  },
};
